import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { envs } from '@config/envs'
import { hermesLogger } from '@core/observability'
import { createClient } from 'graphql-ws'

const _client = createClient({
  url: envs.graphqlWsUrl,
  keepAlive: 5_000,
  shouldRetry: (error) => {
    hermesLogger.warn(`[subscription] retry connection`, { error })
    return true
  },
  lazy: false,
  lazyCloseTimeout: 1000,
  on: {
    closed: async (error) => {
      hermesLogger.warn(`[subscription] socket closed`, { error })
    },
    error: (error) => {
      hermesLogger.error(`[subscription] socket error`, { error })
    },
  },
})

export const wsMiddleware = () => new GraphQLWsLink(_client)

export const closeWsConnection = () => {
  if (_client) {
    _client.dispose()
  }
}
